import { consoleEvents } from '@pb/utils'
import { compose, map, head, prop, groupBy } from 'ramda'

type GroupByPropFn = {
  <T>(arg: T[]): Record<string, T>
}
// groupByProp :: ([{a: 'uniqId', b: true }]) -> { uniqId: {a: 'uniqId', b: true } }
export const groupByProp = (groupProp: string): GroupByPropFn =>
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  compose(map(head), groupBy(prop(groupProp)))

// log :: (*) -> *
export const log = (x): any => {
  // eslint-disable-next-line no-console
  consoleEvents.info(x)
  return x
}
